import PropTypes from "prop-types";
import styles from "./DateHeader.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { SelectDropdown } from "../SelectDropdown/SelectDropdown";
import { useTranslation } from "react-i18next";

export const DateHeader = ({
  month,
  year,
  onNext,
  onBack,
  onMonthChange,
  onYearChange,
  hideArrows = false,
  yearVisibleOptionsCount,
  monthVisibleOptionsCount,
}) => {
  const { t } = useTranslation();
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonthIndex = currentDate.getMonth();

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const years = Array.from(
    { length: currentYear - 1900 + 1 },
    (_, i) => currentYear - i
  );

  const selectedMonthIndex = months.findIndex((m) => m === month);

  const isAtCurrentMonthAndYear =
    year == currentYear && selectedMonthIndex >= currentMonthIndex;

  return (
    <div className={styles.container}>
      {!hideArrows && (
        <div className={styles.back_button} onClick={onBack}>
          <FontAwesomeIcon icon={faChevronLeft} />
        </div>
      )}

      <SelectDropdown
        options={years}
        onChange={onYearChange}
        placeholder={year}
        disabled={false}
        isScrollable={true}
        visibleOptionsCount={yearVisibleOptionsCount}
      />
      <div className={styles.divider}></div>
      <SelectDropdown
        options={
          year < currentYear ? months : months.slice(0, currentMonthIndex + 1)
        }
        onChange={onMonthChange}
        placeholder={t(month)}
        disabled={false}
        isScrollable={true}
        visibleOptionsCount={monthVisibleOptionsCount}
      />
      {!hideArrows && (
        <div
          className={styles.next_button}
          onClick={isAtCurrentMonthAndYear ? undefined : onNext}
        >
          <FontAwesomeIcon icon={faChevronRight} />
        </div>
      )}
    </div>
  );
};

DateHeader.propTypes = {
  month: PropTypes.string.isRequired,
  year: PropTypes.number.isRequired,
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onMonthChange: PropTypes.func.isRequired,
  onYearChange: PropTypes.func.isRequired,
  yearVisibleOptionsCount: PropTypes.number,
  monthVisibleOptionsCount: PropTypes.number,
};
